// 应用全局配置
module.exports = {
  /**
   * 访问IP
   */
  baseUrl: 'https://dapi.baokuanxia.com',
  javaUrl: 'https://jjgzs2024.com:8081',
  /**
   * 超时时间
   */
  timeout: 10000,
  VUE_APP_BASE_API_ROUTE: '/index/index',
  /**
  * 加密token
  */
  aes_token: 'a34bb9e73e35224e17b586d2461116d2',
  /**
 * 加密开关
 */
  encryption: false,
  VUE_APP_UPLOAD_PIC: '/common/upload-pic',
}
